"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToMean = exports.timeFinishedIsInTheFuture = exports.calculateMean = exports.updateLastStudied = exports.updateModulesIncorrect = exports.isModuleCorrect = exports.calculateCappedSessionDuration = exports.epochSecondsToDate = exports.dateToEpochSeconds = exports.validateSessionEvent = void 0;
var validateSessionEvent_1 = require("./validateSessionEvent/validateSessionEvent");
Object.defineProperty(exports, "validateSessionEvent", { enumerable: true, get: function () { return validateSessionEvent_1.validateSessionEvent; } });
__exportStar(require("./aggregateModuleStats"), exports);
var dateToEpochSeconds_1 = require("./utils/dateToEpochSeconds");
Object.defineProperty(exports, "dateToEpochSeconds", { enumerable: true, get: function () { return __importDefault(dateToEpochSeconds_1).default; } });
var epochSecondsToDate_1 = require("./utils/epochSecondsToDate");
Object.defineProperty(exports, "epochSecondsToDate", { enumerable: true, get: function () { return __importDefault(epochSecondsToDate_1).default; } });
var calculateCappedSessionDuration_1 = require("./utils/calculateCappedSessionDuration");
Object.defineProperty(exports, "calculateCappedSessionDuration", { enumerable: true, get: function () { return __importDefault(calculateCappedSessionDuration_1).default; } });
__exportStar(require("./types/Session"), exports);
__exportStar(require("./aggregateSectionStats"), exports);
__exportStar(require("./consts"), exports);
var isModuleCorrect_1 = require("./utils/isModuleCorrect");
Object.defineProperty(exports, "isModuleCorrect", { enumerable: true, get: function () { return __importDefault(isModuleCorrect_1).default; } });
var updateModulesIncorrect_1 = require("./aggregateCourseStats/updateModulesIncorrect");
Object.defineProperty(exports, "updateModulesIncorrect", { enumerable: true, get: function () { return __importDefault(updateModulesIncorrect_1).default; } });
var updateLastStudied_1 = require("./utils/updateLastStudied");
Object.defineProperty(exports, "updateLastStudied", { enumerable: true, get: function () { return __importDefault(updateLastStudied_1).default; } });
var calculateMean_1 = require("./utils/calculateMean");
Object.defineProperty(exports, "calculateMean", { enumerable: true, get: function () { return __importDefault(calculateMean_1).default; } });
var timeFinishedIsInTheFuture_1 = require("./utils/timeFinishedIsInTheFuture");
Object.defineProperty(exports, "timeFinishedIsInTheFuture", { enumerable: true, get: function () { return __importDefault(timeFinishedIsInTheFuture_1).default; } });
var addToMean_1 = require("./utils/addToMean");
Object.defineProperty(exports, "addToMean", { enumerable: true, get: function () { return __importDefault(addToMean_1).default; } });
__exportStar(require("./aggregateQuizStats"), exports);
__exportStar(require("./types/Quiz"), exports);
__exportStar(require("./aggregateCourseStats"), exports);
